import { defineMessages } from 'react-intl';

export const messages = {
  add: {
    id: 'arrayField.actions.add',
    defaultMessage: 'Add',
    description: 'label of the add button',
  },
  remove: {
    id: 'arrayField.actions.remove',
    defaultMessage: 'Remove',
    description: 'label of the remove button',
  },
};

export default defineMessages(messages);
